import * as i0 from '@angular/core';
import { Component, Inject, NgModule } from '@angular/core';
import * as i1 from '@angular/material/dialog';
import { MatDialog, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i1$1 from '@ngx-translate/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import * as i2 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from '@angular/forms';
import { FormsModule } from '@angular/forms';

class ServiceLocator {
}

class Dialog {
    constructor(dialogBuilder) {
        this.dialog = ServiceLocator.injector.get(MatDialog);
        this.showWith(dialogBuilder);
    }
    /**
     * Display a Dialog with the options of the DialogsBuilder
     * @param dialogBuilder
     */
    showWith(dialogBuilder) {
        this.dialog.open(DialogsComponent, {
            data: dialogBuilder,
            panelClass: 'bt-dialog-overlay',
        });
    }
    static translate(key) {
        try {
            const translate = ServiceLocator.injector.get(TranslateService);
            this.setTranslations(translate);
            this.setTranslations(translate);
            console.log(translate.currentLang);
            return translate.instant(key);
        }
        catch (e) {
            return key;
        }
    }
    static showDialog(title, message) {
        new DialogBuilder()
            .setTitle(title)
            .setMessage(message)
            .setBtnNOK(this.translate('Ok'))
            .build();
    }
    static showErrorDialog(message) {
        this.showDialog(this.translate('Error'), message);
    }
    static showAlertDialog(message) {
        this.showDialog(this.translate('Warning'), message);
    }
    static showSuccessDialog(message) {
        this.showDialog(this.translate('Success'), message);
    }
    static setTranslations(translateService) {
        translateService.setTranslation('es', {
            Ok: 'OK',
            Error: 'Error',
            Warning: 'Atención',
            Success: 'Éxito',
            Cancel: 'Cancelar',
        });
        translateService.setTranslation('ca', {
            Ok: 'OK',
            Error: 'Error',
            Warning: 'Atenció',
            Success: 'Èxit',
            Cancel: 'Cancel·lar',
        });
        translateService.setTranslation('en', {
            Ok: 'OK',
            Error: 'Error',
            Warning: 'Warning',
            Success: 'Success',
            Cancel: 'Cancel',
        });
    }
}

class DialogBuilder {
    constructor() {
        this._list = [];
        this._type = ListType.SINGLE_CHOICE;
        this._selectedItem = 0;
        this._checkedItems = [];
        this._cancelable = false; //Can click out of the dialog to exit
        this._onClickOK = () => { };
        this._onClickNOK = () => { };
        this._onClickNeutral = () => { };
        this._onChangeList = () => { };
        this._onChangeMultiChoiceList = () => { };
    }
    build() {
        new Dialog(this);
    }
    get title() {
        return this._title;
    }
    setTitle(value) {
        this._title = value;
        return this;
    }
    get message() {
        return this._message;
    }
    setMessage(value) {
        this._message = value;
        return this;
    }
    get list() {
        return this._list;
    }
    setList(value) {
        this._list = value;
        return this;
    }
    get type() {
        return this._type;
    }
    setType(value) {
        this._type = value;
        return this;
    }
    get selectedItem() {
        return this._selectedItem;
    }
    setSelectedItem(value) {
        this._selectedItem = value;
        return this;
    }
    get checkedItems() {
        return this._checkedItems;
    }
    setCheckedItems(value) {
        this._checkedItems = value;
        return this;
    }
    get btnOK() {
        return this._btnOK;
    }
    setBtnOK(value) {
        this._btnOK = value;
        return this;
    }
    get btnNOK() {
        return this._btnNOK;
    }
    setBtnNOK(value) {
        this._btnNOK = value;
        return this;
    }
    get btnNeutral() {
        return this._btnNeutral;
    }
    setBtnNeutral(value) {
        this._btnNeutral = value;
        return this;
    }
    get cancelable() {
        return this._cancelable;
    }
    setCancelable(value) {
        this._cancelable = value;
        return this;
    }
    onClickOK() {
        this._onClickOK();
    }
    setOnClickOK(value) {
        this._onClickOK = value;
        return this;
    }
    onClickNeutral() {
        this._onClickNeutral();
    }
    setOnClickNeutral(value) {
        this._onClickNeutral = value;
        return this;
    }
    onClickNOK() {
        this._onClickNOK();
    }
    setOnClickNOK(value) {
        this._onClickNOK = value;
        return this;
    }
    onChangeList(index) {
        this._onChangeList(index);
    }
    setOnChangeList(value) {
        this._onChangeList = value;
        return this;
    }
    onChangeMultiChoiceList(indexes) {
        this._onChangeMultiChoiceList(indexes);
    }
    setOnChangeMultiChoiceList(value) {
        this._onChangeMultiChoiceList = value;
        return this;
    }
}
var ListType;
(function (ListType) {
    ListType[ListType["SINGLE_CHOICE"] = 0] = "SINGLE_CHOICE";
    ListType[ListType["RADIO_BUTTON"] = 1] = "RADIO_BUTTON";
    ListType[ListType["CHECKBOX"] = 2] = "CHECKBOX";
})(ListType || (ListType = {}));

class DialogsComponent {
    constructor(data, dialogRef) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.selectedItem = this.data.selectedItem;
    }
    ngOnInit() {
        if (!this.data.cancelable) {
            this.dialogRef.disableClose = true;
        }
    }
    onClickOK() {
        this.data.onClickOK();
        this.dialogRef.close();
    }
    onClickNOK() {
        this.data.onClickNOK();
        this.dialogRef.close();
    }
    onClickNeutral() {
        this.data.onClickNeutral();
        this.dialogRef.close();
    }
    onChangeList(index) {
        this.data.onChangeList(index);
    }
    get ListType() {
        return ListType;
    }
}
DialogsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.8", ngImport: i0, type: DialogsComponent, deps: [{ token: MAT_DIALOG_DATA }, { token: i1.MatDialogRef }], target: i0.ɵɵFactoryTarget.Component });
DialogsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.8", type: DialogsComponent, selector: "bt-dialog", ngImport: i0, template: `
    <h1 mat-dialog-title>{{ data.title }}</h1>
    <mat-dialog-content>
      <p>
        {{ data.message }}
      </p>

      <ng-container *ngIf="data.list.length > 0" [ngSwitch]="data.type">
        <select
          *ngSwitchCase="ListType.SINGLE_CHOICE"
          [(ngModel)]="selectedItem"
          (ngModelChange)="onChangeList($event)"
        >
          <option *ngFor="let option of data.list; let i = index" [ngValue]="i">
            {{ option }}
          </option>
        </select>

        <ul *ngSwitchCase="ListType.RADIO_BUTTON">
          <li *ngFor="let option of data.list; let i = index">
            <input
              type="radio"
              [id]="i"
              name="0"
              [(ngModel)]="selectedItem"
              (ngModelChange)="onChangeList($event)"
              [value]="i"
            />
            <label [for]="i"> {{ option }} </label>
          </li>
        </ul>
      </ng-container>
    </mat-dialog-content>

    <mat-dialog-actions
      class="actions"
      *ngIf="data.btnOK || data.btnNeutral || data.btnNOK"
    >
      <button
        class="action-neutral"
        mat-button
        *ngIf="data.btnNeutral"
        (click)="onClickNeutral()"
      >
        {{ data.btnNeutral }}
      </button>
      <button mat-button *ngIf="data.btnNOK" (click)="onClickNOK()">
        {{ data.btnNOK }}
      </button>
      <button
        mat-button
        cdkFocusInitial
        *ngIf="data.btnOK"
        (click)="onClickOK()"
      >
        {{ data.btnOK }}
      </button>
    </mat-dialog-actions>
  `, isInline: true, styles: ["mat-dialog-actions{justify-content:flex-end}.action-neutral{margin-right:auto}\n"], components: [{ type: i2.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }], directives: [{ type: i1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { type: i1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i3.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i4.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i4.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i4.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i4.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i4.RadioControlValueAccessor, selector: "input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]", inputs: ["name", "formControlName", "value"] }, { type: i4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.8", ngImport: i0, type: DialogsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bt-dialog',
                    template: `
    <h1 mat-dialog-title>{{ data.title }}</h1>
    <mat-dialog-content>
      <p>
        {{ data.message }}
      </p>

      <ng-container *ngIf="data.list.length > 0" [ngSwitch]="data.type">
        <select
          *ngSwitchCase="ListType.SINGLE_CHOICE"
          [(ngModel)]="selectedItem"
          (ngModelChange)="onChangeList($event)"
        >
          <option *ngFor="let option of data.list; let i = index" [ngValue]="i">
            {{ option }}
          </option>
        </select>

        <ul *ngSwitchCase="ListType.RADIO_BUTTON">
          <li *ngFor="let option of data.list; let i = index">
            <input
              type="radio"
              [id]="i"
              name="0"
              [(ngModel)]="selectedItem"
              (ngModelChange)="onChangeList($event)"
              [value]="i"
            />
            <label [for]="i"> {{ option }} </label>
          </li>
        </ul>
      </ng-container>
    </mat-dialog-content>

    <mat-dialog-actions
      class="actions"
      *ngIf="data.btnOK || data.btnNeutral || data.btnNOK"
    >
      <button
        class="action-neutral"
        mat-button
        *ngIf="data.btnNeutral"
        (click)="onClickNeutral()"
      >
        {{ data.btnNeutral }}
      </button>
      <button mat-button *ngIf="data.btnNOK" (click)="onClickNOK()">
        {{ data.btnNOK }}
      </button>
      <button
        mat-button
        cdkFocusInitial
        *ngIf="data.btnOK"
        (click)="onClickOK()"
      >
        {{ data.btnOK }}
      </button>
    </mat-dialog-actions>
  `,
                    styleUrls: [
                        'dialogs.component.scss'
                    ],
                }]
        }], ctorParameters: function () { return [{ type: DialogBuilder, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: i1.MatDialogRef }]; } });

class DialogsModule {
    constructor(injector) {
        this.injector = injector;
        // Create global Service Injector.
        ServiceLocator.injector = this.injector;
    }
}
DialogsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.8", ngImport: i0, type: DialogsModule, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.NgModule });
DialogsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.8", ngImport: i0, type: DialogsModule, declarations: [DialogsComponent], imports: [CommonModule,
        MatDialogModule,
        MatButtonModule,
        FormsModule, i1$1.TranslateModule], exports: [DialogsComponent] });
DialogsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.8", ngImport: i0, type: DialogsModule, imports: [[
            CommonModule,
            MatDialogModule,
            MatButtonModule,
            FormsModule,
            TranslateModule.forChild({
                extend: true,
                isolate: false
            }),
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.8", ngImport: i0, type: DialogsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DialogsComponent],
                    imports: [
                        CommonModule,
                        MatDialogModule,
                        MatButtonModule,
                        FormsModule,
                        TranslateModule.forChild({
                            extend: true,
                            isolate: false
                        }),
                    ],
                    exports: [DialogsComponent],
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }]; } });

/*
 * Public API Surface of dialogs
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Dialog, DialogBuilder, DialogsComponent, DialogsModule, ListType };
